import React, { useEffect, useState } from "react";
import { FaCirclePlus } from "react-icons/fa6";
import Discover from "../Components/Discover";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import { useDispatch, useSelector } from "react-redux";
import {
  addCart,
  addGlbRow,
  addProductRow,
  addTempProductRow,
  deleteEntireGlbCart,
  deleteEntireProductCart,
  deleteGlbRow,
  deleteProductRow,
  removeCart,
  removeTempProductRow,
  setGlbItems,
  setSelectedSizeDetails,
  updateCartItem,
  updateCartQuantity,
  updateCartSize,
  updateGlbRow,
  updateProductRow,
  updateTempProductRow,
} from "../../Redux/Cart_System";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import {
  addToCart,
  config_Api,
  Coupon_data,
  getCart,
  getCoupons,
  glbGetSize,
  homefilterApi,
  productDetails,
  removeCartItem,
  stockCheck,
  updateCartQuantityAPI,
} from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import "../../Styles/Cart.css";
import { size } from "lodash";
import { RiDeleteBin5Line } from "react-icons/ri";
import { MdAdd } from "react-icons/md";

const Loader = () => {
  return (
    <div className="skeleton-loader">
      <div className="skeleton-header"></div>
      <div className="skeleton-content">
        {[...Array(3)].map((_, index) => (
          <div key={index} className="skeleton-item">
            <div className="skeleton-image"></div>
            <div className="skeleton-details">
              <div className="skeleton-line short"></div>
              <div className="skeleton-line medium"></div>
              <div className="skeleton-line long"></div>
            </div>
          </div>
        ))}
      </div>
      <style jsx>{`
        .skeleton-loader {
          width: 100%;
          padding: 20px;
        }
        .skeleton-header {
          height: 40px;
          background: #e0e0e0;
          margin-bottom: 20px;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }
        .skeleton-content {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .skeleton-item {
          display: flex;
          gap: 15px;
          padding: 15px;
          background: #f5f5f5;
          border-radius: 8px;
        }
        .skeleton-image {
          width: 100px;
          height: 100px;
          background: #e0e0e0;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }
        .skeleton-details {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .skeleton-line {
          height: 12px;
          background: #e0e0e0;
          border-radius: 4px;
          animation: pulse 1.5s infinite ease-in-out;
        }
        .skeleton-line.short {
          width: 40%;
        }
        .skeleton-line.medium {
          width: 60%;
        }
        .skeleton-line.long {
          width: 80%;
        }
        @keyframes pulse {
          0% {
            opacity: 0.6;
          }
          50% {
            opacity: 0.3;
          }
          100% {
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  );
};

const CartSec = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [mobile,setMobile]=useState(window.innerWidth<567?true:false)
  const [quantity, setQuantity] = useState(0);
  const [couponCode, setCouponCode] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [sizeAll, setSize] = useState([]);
  const [product, setProduct] = useState([]);
  const [glb, setGlb] = useState([]);
  const [sizeId, setSizeId] = useState("");
  const [couponMessage, setCouponMessage] = useState("");
  const cartItemsFromRedux = useSelector((state) => state.cart.items);
  //console.log("cartItemsFromRedux : ", cartItemsFromRedux);
  const { tokenDetails } = useSelector((state) => state.user);
  const { configUrl } = useSelector((state) => state.cart);
  const { baseAssetUrl } = useSelector((state) => state.cart);
  //console.log("baseAssetUrl : ", baseAssetUrl);
  const [cartUpdated, setCartUpdated] = useState(false);
  //console.log("configUrl : ", configUrl);
  const token = tokenDetails;
  // const [isLoading, setIsLoading] = useState(false);
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [isCheckingOut, setIsCheckingOut] = useState(false);
  const [loadingButtons, setLoadingButtons] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [tempRows, setTempRows] = useState({});
  console.log("tempRows : ", tempRows);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const { glbItems, productItems } = useSelector((state) => state.cart);
  console.log("productItems : ", productItems);

  const [quantityDiscounts, setQuantityDiscounts] = useState([]);
  const[couponList,setCouponList]=useState([])
  const [couponDiscount,setCouponDiscount]=useState("")


  const handleGetCoupon=async()=>{
    try {
      const response=await getCoupons(token)
      console.log("coupon list",response.data);
      setCouponList(response.data.data)

    
      
      
    } catch (error) {
      console.log(error);
      
    }
  }
  useEffect(() => {
    handleGetCoupon()
  }, [])
  

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await config_Api();
        console.log(
          "response for quantityDiscount : ",
          response?.data?.quantityDiscount
        );

        if (response.success === true) {
          setQuantityDiscounts(response?.data?.quantityDiscount || []);
        }
      } catch (error) {
        console.error("Error updating profile:", error);
      }
    };

    fetchConfig();

  }, [dispatch]);

  useEffect(() => {
    const fetchSize = async () => {
      try {
        const response = await glbGetSize();
        //console.log("fetch size : ", response);
        if (response.success) {
          setSize(response.data);
        }
      } catch (error) {
        console.error("Error fetching:", error);
      }
    };

    fetchSize();
  }, []);

  useEffect(() => {
    const fetchCart = async () => {
      try {
        const response = await getCart(tokenDetails);
        console.log("response.data.glb :", response.data.glb);
        const glbFromBackend = response.data.glb;

        setProduct(response.data.product);
        setGlb(glbFromBackend);

        glbFromBackend?.forEach((glbItem) => {
          const cartId = glbItem.cart_id;
          const existingItem = glbItems.find((g) => g.cart_id === cartId);

          if (existingItem) return;

          const rows = glbItem?.data?.filter(Boolean) || [];

          console.log("rows : ", rows);

          rows.forEach((row) => {
            dispatch(
              addGlbRow({
                cart_id: cartId,
                row: {
                  id: row.id,
                  name: row.name || "",
                  number: row.number || "",
                  size_id: row.size_id || "",
                  qty: row.qty || 1,
                  price: row.total_amount,
                },
              })
            );
          });
        });
      } catch (error) {
        console.error("Error fetching cart:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCart();
  }, [cartUpdated]);

  if (isLoading) {
    return <Loader />;
  }

  const removeItem = async (id) => {
    try {
      console.log("id : ", id);
      setLoadingButtons((prev) => ({ ...prev, [id]: true }));
      //console.log("item : ", id);
      // await new Promise((resolve) => setTimeout(resolve, 5000));

      const formData = new FormData();
      formData.append("cartId", id);
      const response = await removeCartItem(formData, tokenDetails);
      console.log("API response for cart delete :", response);

      if (response.success === true) {
        setCartUpdated((prev) => !prev);
      } else {
        //toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during product API call:", error);
    } finally {
      setLoadingButtons((prev) => ({ ...prev, [id]: false }));
    }
  };

  const handleProceedToCheckout = async (product, glb) => {
    setIsCheckingOut(true);
    await new Promise((resolve) => setTimeout(resolve, 3000));

    if (!token) {
      navigate("/auth", { state: { from: location.pathname } });

      setIsCheckingOut(false);
    } else {
      const idsToRemove = glb.flatMap((g) => g.data.map((item) => item.id));

      const updatedGlbItems = glbItems
        .map((glbItem) => ({
          ...glbItem,
          data: glbItem.data.filter((item) => !idsToRemove.includes(item.id)),
        }))
        .filter((glbItem) => glbItem.data.length > 0);

      const enrichedGlbItems = glbItems.map((glbItem) => {
        const matchingGlb = glb.find((g) => g.cart_id === glbItem.cart_id);
        return {
          ...glbItem,
          glb_image: matchingGlb?.glb_image || "",
          image: matchingGlb?.image || "",
          name: matchingGlb?.name || "",
        };
      });

      const remainingProductItems = productItems
        .map((product) => ({
          ...product,
          data: product.data.filter((_, index) => index !== 0), // Remove first item
        }))
        .filter((product) => product.data.length > 0);

      console.log("Enriched glbItems:", enrichedGlbItems);
      console.log("glbItem:", glbItems);
      console.log("Updated glbItems (filtered):", updatedGlbItems);

      navigate("/checkout", {
        state: {
          product: productItems,
          remainingProductItems,
          glb: enrichedGlbItems,
          remainingGlbItems: updatedGlbItems,
          totalPrice1: totalPrice,
          discountAmount: discountAmount,
          quantityDiscountAmount: quantityDiscountAmount,
          payableAmount: payableAmount,
          couponCode,
        },
      });
      setIsCheckingOut(false);
    }
  };

  const applyCoupon = async () => {
    try {
      setIsApplyingCoupon(true);
      await new Promise((resolve) => setTimeout(resolve, 3000));
      const formData = new FormData();
      //console.log("couponCode : ", couponCode);
      //console.log("totalPrice : ", totalPrice);
      formData.append("couponCode", couponCode);
      formData.append("totalAmount", totalPrice);
      const result = await Coupon_data(formData, token);
      if (result.success === true) {
        setCouponMessage(result.data[0].description);
        setDiscountAmount(result.data[0].discountAmount);
        toast.success("Coupon applied successfully");
      } else {
        setCouponMessage("Invalid coupon code.");
        setDiscountAmount(0);
        //toast.error("Invalid coupon code");
      }
    } catch (error) {
      //toast.error("please login (token invalid)");
      console.error("Error applying coupon:", error);
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  const handleGlbSizeIdChange = (cart_id, data_id, value) => {
    console.log("data_id : ", data_id);
    dispatch(updateGlbRow({ cart_id, data_id, key: "size_id", value }));

    const selectedSize = sizeAll.find((size) => size.id === value);
    if (selectedSize) {
      dispatch(setSelectedSizeDetails(selectedSize));
    }
  };

  const handleGlbInputChange = (cart_id, data_id, key, value) => {
    dispatch(updateGlbRow({ cart_id, data_id, key, value }));
  };

  const handleGlbIncrement = (cart_id, data_id, currentQty) => {
    dispatch(
      updateGlbRow({ cart_id, data_id, key: "qty", value: currentQty + 1 })
    );
  };

  const handleGlbDecrement = (cart_id, data_id, currentQty) => {
    if (currentQty > 1) {
      dispatch(
        updateGlbRow({ cart_id, data_id, key: "qty", value: currentQty - 1 })
      );
    }
  };

  const handleRemoveRow = (cart_id, data_id) => {
    console.log("cart_id : ", cart_id);
    console.log("data_id : ", data_id);
    console.log("glb : ", glb);
    console.log("glbItems : ", glbItems);
    dispatch(deleteGlbRow({ cart_id, data_id }));
    //    const glbItemExists = glb.some(item =>
    //   item.cart_id === cart_id ||
    //   item.data.some(dataItem => dataItem.id === data_id)
    // );

    // if (glbItemExists) {
    //   removeItem(data_id);
    // }
  };

  const handleAddRow = (cartId,cart) => {
    console.log("cart_id : ", cart);
    if (!sizeAll || sizeAll.length === 0) return;

    const existingCart = glbItems.find((item) => item.cart_id === cartId);
    const priceFromFirstRow = existingCart?.data?.[0]?.price || 0;

    const newRow = {
      id: Date.now(),
      name: "",
      number: "",
      size_id: sizeAll[0].id,
      qty: 1,
      price: priceFromFirstRow,
    };

    setTempRows((prevTempRows) => {
      const updated = {
        ...prevTempRows,
        [cartId]: [...(prevTempRows[cartId] || []), newRow],
      };

      dispatch(
        addGlbRow({
          cart_id: cartId,
          row: newRow,
        })
      );

      const { [cartId]: _, ...rest } = updated;
      return rest;
    });
  };

  const productTotal = productItems.reduce((sum, productItem) => {
    return (
      sum +
      productItem.data.reduce(
        (dataSum, prod) => dataSum + prod.qty * productItem.product_price,
        0
      )
    );
  }, 0);

  console.log(productTotal);

  const glbTotal = glbItems.reduce((sum, productItem) => {
    return (
      sum +
      productItem.data.reduce(
        (dataSum, prod) => dataSum + prod.qty * prod.price,
        0
      )
    );
  }, 0);

  const totalPrice = productTotal + glbTotal;
  // const payableAmount = discountAmount
  //   ? totalPrice - discountAmount
  //   : totalPrice;

  console.log("glb Items : ", glbItems);
  console.log("Product : ", product);

  const calculateTotalQuantity = () => {
    let totalQty = 0;

    productItems.forEach((prod) => {
      prod.data.forEach((item) => {
        totalQty += item.qty || 0;
      });
    });

    glbItems.forEach((cart) => {
      cart.data.forEach((item) => {
        totalQty += item.qty || 0;
      });
    });

    console.log("totalQty : ", totalQty);
    return totalQty;
  };

  const getQuantityDiscount = (totalQty) => {
    console.log("quantityDiscounts : ", quantityDiscounts);
    console.log("totalQty : ", totalQty);

    const sortedDiscounts = [...quantityDiscounts].sort(
      (a, b) => a.min_qty - b.min_qty
    );
    console.log("sortedDiscounts : ", sortedDiscounts);

    let applicableDiscount = null;

    for (const discount of sortedDiscounts) {
      if (totalQty >= discount.min_qty && totalQty <= discount.max_qty) {
        applicableDiscount = discount;
      }
    }

    if (!applicableDiscount && sortedDiscounts.length > 0) {
      const lastDiscount = sortedDiscounts[sortedDiscounts.length - 1];
      if (totalQty > lastDiscount.max_qty) {
        applicableDiscount = lastDiscount;
      }
    }

    console.log("applicableDiscount : ", applicableDiscount);
    return applicableDiscount;
  };

  const calculateQuantityDiscount = () => {
    const totalQty = calculateTotalQuantity();
    const discount = getQuantityDiscount(totalQty);

    if (!discount) return 0;

    const discountPercentage = totalQty>9?13:0
    return  discountPercentage;
  };

  const quantityDiscountAmount = calculateQuantityDiscount();

  const payableAmount = totalPrice - (discountAmount + quantityDiscountAmount) ;

  const handleInputChange = (product_id, row_id, key, value) => {
    dispatch(updateProductRow({ product_id, row_id, key, value }));
  };

  const handleSizeChange = (product_id, row_id, value) => {
    dispatch(updateProductRow({ product_id, row_id, key: "size_id", value }));
  };

  const handleColorChange = (product_id, row_id, value) => {
    dispatch(updateProductRow({ product_id, row_id, key: "color_id", value }));
  };

  const handleIncrementProduct = (product_id, row_id, currentQty) => {
    dispatch(
      updateProductRow({
        product_id,
        row_id,
        key: "qty",
        value: currentQty + 1,
      })
    );
  };

  const handleDecrementProduct = (product_id, row_id, currentQty) => {
    if (currentQty > 1) {
      dispatch(
        updateProductRow({
          product_id,
          row_id,
          key: "qty",
          value: currentQty - 1,
        })
      );
    }
  };

  const handleRemoveRowProduct = (product_id, row_id) => {
    dispatch(deleteProductRow({ product_id, row_id }));
  };

  const handleAddRowProduct = (product_id,product) => {
    console.log("product : ",product)
    // if (!sizeAll || sizeAll.length === 0) return;
    console.log("productItems : ",productItems)

    const existingProduct = productItems.find(
      (item) => item.product_id === product_id
    );
    const priceFromFirstRow = existingProduct?.data?.[0]?.product_price || 0;

    const matchedColorId = existingProduct?.data?.[0]?.color_id ;
    console.log("matchedColorId : ",matchedColorId)

    const newRow = {
      id: Date.now(),
      name: "",
      number: "",
      size_id: product.All_Color[0].color_id,
      qty: 1,
      color_id : matchedColorId,
    };
    setTempRows((prevTempRows) => {
      const updated = {
        ...prevTempRows,
        [product_id]: [...(prevTempRows[product_id] || []), newRow],
      };

      dispatch(addProductRow({ product_id, row: newRow }));
      const { [product_id]: _, ...rest } = updated;
      return rest;
    });
  };

  const handleTempRowChangeProduct = (product_id, row_id, key, value) => {
    dispatch(updateTempProductRow({ product_id, row_id, key, value }));
  };

  const handleRemoveTempRow = (product_id, row_id) => {
    dispatch(removeTempProductRow({ product_id, row_id }));
  };

    const handleSportClick = async (categoryName) => {
      try {
        console.log("categoryName : ", categoryName);
        const products = await homefilterApi(categoryName);
        console.log("Products for:", categoryName, products);
  
        navigate("/AllListingPage", {
          state: {
            products: products.data,
          },
        });
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    const calculateCouponDiscount=(list,length)=>{

      let dis=5;
      for(let d in list){
        if(d.max_qty>=length &&d.min_qty<=length){
          dis=d.discount_percentage
          setCouponDiscount(dis)
        }
        else{
          continue
        }
      }
      return dis;
    }

  return (
    <>
      

      <>
        {product.length === 0 && glb.length === 0 ? (
          <div
            style={{
              flex: "1",
              minWidth: "280px",
              backgroundColor: "#f9f9f9",
              padding: "15px",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              textAlign: "center",
              height: "89.7vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <p
              style={{
                color: "#ff5c5c",
                fontSize: "1rem",
                fontWeight: "700",
              }}
            >
              Your cart is empty
            </p>
            <p
              style={{
                color: "#555",
                fontSize: "1.2em",
              }}
            >
              Looks like you haven't added anything to your cart yet.
            </p>
          </div>
        ) : (
          <div className="max-w-5xl mx-auto p-6" style={{ marginTop: "120px" }}>
            <p
              className="text-2xl font-bold mb-6 text-center"
              style={{
                borderBottom: "3px solid rgb(76, 175, 80)",
                paddingBottom: "10px",
                fontSize: "24px",
                fontWeight:"bold",
                fontFamily:"Poppins"
              }}
            >
              Cart Section
            </p>
            <div
              className="table-wrapper"
              style={{ width: "97%", margin: "auto" }}
            >
              <div
                className="table-scroll"
                style={{
                  gap: "30px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {productItems?.map((item) => (
                  <div key={item.product_id}>
                    <div
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        backgroundColor: "#fff",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "16px",
                          backgroundColor: "#f8f8f8",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "16px 80px 16px 16px",
                          border: "1px solid #d1d1d1",
                          borderRadius: "8px 8px 0 0",
                        }}
                        className="productItems-image-container"
                      >
                        <img
                          src={item.product_image}
                          width="100"
                          style={{ borderRadius: "8px" }}
                          alt="Product Preview"
                        />
                        <div>
                          <p
                            style={{
                              fontWeight: "bold",
                              fontSize: "1.125rem",
                              fontFamily:"Poppins"
                            }}
                          >
                            {item.product_name}
                          </p>
                          <div>
                            <p style={{ color: "#4B5563" }}>
                              Price: ${item?.product_price || "N/A"}
                            </p>
                          </div>
                          <div>
                            <p style={{ color: "#4B5563" }}>
                              Color: {item?.data[0]?.color_name}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          overflowX: "auto",
                          width: "100%",
                          WebkitOverflowScrolling: "touch",
                          scrollbarWidth: "none",
                          msOverflowStyle: "none",
                        }}
                        className="w-full no-scrollbar"
                      >
                        <table
                          className="table-auto w-full border border-gray-300 m-auto"
                          style={{
                            position: "relative",
                            minWidth: "700px",
                            borderCollapse: "collapse",
                            width: "100%",
                          }}
                        >
                          <thead>
                            <tr className="bg-gray-100">
                              <th className="border border-gray-300 px-4 py-2" style={{ fontSize:mobile?"10px": "16px" }}>#</th>
                              <th
                                className="border border-gray-300 px-4 py-2"
                                style={{ fontSize:mobile?"10px": "16px" }}
                              >
                                Size
                              </th>
                              {/* <th
                                className="border border-gray-300 px-4 py-2"
                                style={{ fontSize: "16px" }}
                              >
                                Color
                              </th> */}
                              <th
                                className="border border-gray-300 px-4 py-2"
                                style={{ fontSize:mobile?"10px": "16px" }}
                              >
                                Name
                              </th>
                              <th
                                className="border border-gray-300 px-4 py-2"
                                style={{ fontSize:mobile?"10px": "16px" }}
                              >
                                Number
                              </th>

                              <th
                                className="border border-gray-300 px-4 py-2"
                                style={{ fontSize:mobile?"10px": "16px" }}
                              >
                                Category
                              </th>

                              <th
                                className="border border-gray-300 px-4 py-2"
                                style={{ fontSize:mobile?"10px": "16px" }}
                              >
                                Quantity
                              </th>
                              <th
                                className="border border-gray-300 px-4 py-2"
                                style={{ fontSize:mobile?"10px": "16px" }}
                              >
                                Action
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.data.map((size, rowIndex) => (
                              <tr key={size.id} className="hover:bg-gray-50" style={{ fontSize:mobile?"10px": "16px" }}>
                                <td className="border border-gray-300 px-4 py-2">
                                  {rowIndex + 1}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <select
                                    className="  bg-transparent text-gray-700 border border-gray-300 rounded-md input-with-left-gap"
                                    value={size.size_id || ""}
                                     style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":"",width:mobile?"50px":""}}
                                    onChange={(e) =>
                                      handleSizeChange(
                                        item.product_id,
                                        size.id,
                                        Number(e.target.value)
                                      )
                                    }
                                    
                                  >
                                    <option value=""  style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":"",width:mobile?"50px":""}}>Select </option>
                                    {/* {sizeAll?.map((sizeOption) => (
                                      <option
                                        key={sizeOption.id}
                                        value={sizeOption.id}
                                      >
                                        {sizeOption.name}
                                      </option>
                                    ))} */}
                                    {item.All_Size?.map((sizeOption) => (
                                      <option
                                        key={sizeOption.size_id}
                                        value={sizeOption.size_id}
                                         style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":"",width:mobile?"50px":""}}
                                      >
                                        {sizeOption.name}
                                      </option>
                                    ))}
                                  </select>
                                </td>
                               
                                <td className="border border-gray-300 " style={{padding:mobile?"3px":"6px"}}>
                                  <input
                                    type="text"
                                    style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":""}}
                                    placeholder="Enter name"
                                    value={size.name || ""}
                                    onChange={(e) =>
                                      handleInputChange(
                                        item.product_id,
                                        size.id,
                                        "name",
                                        e.target.value
                                      )
                                    }
                                    className="w-full  bg-white text-black border border-gray-300 rounded-md input-with-left-gap"
                                  />
                                </td>
                                <td className="border border-gray-300 " style={{padding:mobile?"3px":"6px"}}>
                                  <input
                                    type="number"
                                    style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":""}}
                                    placeholder="Enter jersey number"
                                    value={size.number || ""}
                                    onChange={(e) =>
                                      handleInputChange(
                                        item.product_id,
                                        size.id,
                                        "number",
                                        e.target.value
                                      )
                                    }
                                    className="w-full  bg-white text-black border border-gray-300 rounded-md input-with-left-gap"
                                  />
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <select
                                    className="w-full  bg-transparent text-gray-700 border border-gray-300 rounded-md input-with-left-gap"
                                    value={size.category || ""}
                                    style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":"",width:mobile?"50px":""}}
                                    onChange={(e) =>
                                      handleInputChange(
                                        item.product_id,
                                        size.id,
                                        "category",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value=""   style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":"",width:mobile?"50px":""}}>Select </option>
                                    <option value="Men"   style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":"",width:mobile?"50px":""}}>Men</option>
                                    <option value="Women"   style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":"",width:mobile?"50px":""}}>Women</option>
                                    <option value="Kids"   style={{padding:mobile?"1px":"6px",fontSize:mobile?"8px":"16px",height:mobile?"20px":"",width:mobile?"50px":""}}>Kids</option>
                                  </select>
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <div
                                    className="flex items-center gap-2 justify-center"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <button
                                      onClick={() =>
                                        handleDecrementProduct(
                                          item.product_id,
                                          size.id,
                                          size.qty
                                        )
                                      }
                                      style={{
                                        backgroundColor: "#003366",
                                        borderRadius: "10px",
                                      }}
                                      className="px-3 py-1 text-white rounded-md input-with-left-gap"
                                    >
                                      -
                                    </button>
                                    <span className="text-gray-700">
                                      {size.qty}
                                    </span>
                                    <button
                                      onClick={() =>
                                        handleIncrementProduct(
                                          item.product_id,
                                          size.id,
                                          size.qty
                                        )
                                      }
                                      style={{
                                        backgroundColor: "#003366",
                                        borderRadius: "10px",
                                      }}
                                      className="px-3 py-1 text-white rounded-md input-with-left-gap"
                                    >
                                      +
                                    </button>
                                  </div>
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <div className="flex gap-2">
                                    <button
                                      onClick={() => {
                                        if (rowIndex === 0) {
                                          setDeleteTarget({
                                            cart_id: item.cart_id,
                                            data_id: size.id,
                                            type: "product", // Add type
                                          });
                                          setShowDeleteModal(true);
                                        } else {
                                          handleRemoveRowProduct(
                                            item.product_id,
                                            size.id
                                          );
                                        }
                                      }}
                                      className="px-3 py-1 text-white rounded-md input-with-left-gap"
                                      style={{ backgroundColor: "transparent" }}
                                    >
                                      <RiDeleteBin5Line
                                        style={{ color: "red" }}
                                      />
                                    </button>
                                    <button
                                      onClick={() =>
                                        handleAddRowProduct(item.product_id,item)
                                      }
                                      className="px-3 py-1 text-white rounded-full"
                                      title="Add Row Below"
                                      style={{
                                        backgroundColor: "transparent",
                                      }}
                                    >
                                      <MdAdd
                                        style={{ color: "rgb(0, 51, 102)" }}
                                      />
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))}

                            {tempRows[item.cart_id]?.map((tempRow, index) => (
                              <tr key={tempRow.id} className="hover:bg-gray-50">
                                <td className="border border-gray-300 px-4 py-2">
                                  {item.data.length + index + 1}
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <img
                                    src={`${baseAssetUrl}${item.image}`}
                                    alt="Product"
                                    width="50"
                                  />
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <input
                                    type="text"
                                    placeholder="Enter name"
                                    value={tempRow.name}
                                    onChange={(e) =>
                                      handleTempRowChangeProduct(
                                        item.product_id,
                                        tempRow.id,
                                        "name",
                                        e.target.value
                                      )
                                    }
                                    className="w-full px-3 py-2 bg-white text-black border border-gray-300 rounded-md input-with-left-gap"
                                  />
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <input
                                    type="number"
                                    placeholder="Enter jersey number"
                                    value={tempRow.number}
                                    onChange={(e) =>
                                      handleTempRowChangeProduct(
                                        item.product_id,
                                        tempRow.id,
                                        "number",
                                        e.target.value
                                      )
                                    }
                                    className="w-full px-3 py-2 bg-white text-black border border-gray-300 rounded-md input-with-left-gap"
                                  />
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <select
                                    value={tempRow.size_id || ""}
                                    onChange={(e) =>
                                      handleTempRowChangeProduct(
                                        item.product_id,
                                        tempRow.id,
                                        "size_id",
                                        e.target.value
                                      )
                                    }
                                    className="w-full px-3 py-2 bg-transparent text-gray-700 border border-gray-300 rounded-md input-with-left-gap"
                                  >
                                    <option value="">Select Size</option>
                                    {sizeAll?.map((sizeOption) => (
                                      <option
                                        key={sizeOption.id}
                                        value={sizeOption.id}
                                      >
                                        {sizeOption.name}
                                      </option>
                                    ))}
                                  </select>
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <div className="flex items-center gap-2 justify-center">
                                    <button
                                      style={{
                                        backgroundColor: "#003366",
                                        borderRadius: "10px",
                                      }}
                                      onClick={() =>
                                        handleTempRowChangeProduct(
                                          item.product_id,
                                          tempRow.id,
                                          "qty",
                                          tempRow.qty > 1 ? tempRow.qty - 1 : 1
                                        )
                                      }
                                      className="px-3 py-1 text-white rounded-md input-with-left-gap"
                                    >
                                      -
                                    </button>
                                    <span className="text-gray-700">
                                      {tempRow.qty}
                                    </span>
                                    <button
                                      style={{
                                        backgroundColor: "#003366",
                                        borderRadius: "10px",
                                      }}
                                      onClick={() =>
                                        handleTempRowChangeProduct(
                                          item.product_id,
                                          tempRow.id,
                                          "qty",
                                          tempRow.qty + 1
                                        )
                                      }
                                      className="px-3 py-1 text-white rounded-md input-with-left-gap"
                                    >
                                      +
                                    </button>
                                  </div>
                                </td>
                                <td className="border border-gray-300 px-4 py-2">
                                  <button
                                    onClick={() =>
                                      handleRemoveTempRow(
                                        item.product_id,
                                        tempRow.id
                                      )
                                    }
                                    className="px-3 py-1 text-white rounded-md input-with-left-gap"
                                    style={{
                                      backgroundColor: "transparent",
                                    }}
                                  >
                                    <RiDeleteBin5Line
                                      style={{ color: "red" }}
                                    />
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ))}

              {glb?.map((item) => {
  const matchingGlbItem = glbItems?.find(
    (glbItem) => glbItem.cart_id === item.cart_id
  );

  return (
    <div key={item.cart_id}>
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "16px",
            backgroundColor: "#f8f8f8",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 80px 16px 16px",
            border: "1px solid #d1d1d1",
            borderRadius: "8px 8px 0 0",
          }}
          className="productItems-image-container"
        >
          <img
            src={`${baseAssetUrl}${item.glb_image || item.data[0]?.glb_image}`}
            width="100"
            style={{ borderRadius: "8px" }}
            alt="GLB Preview"
          />
          <div>
            <p
              style={{
                fontWeight: "bold",
                fontSize: "1.125rem",
                fontFamily: "Poppins"
              }}
            >
              {item.name}
            </p>
            <div>
              <p style={{ color: "#4B5563" }}>
                Price: ${item.data[0]?.product_price || "N/A"}
              </p>
            </div>
          </div>
        </div>
        <div
          style={{
            overflowX: "auto",
            width: "100%",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="w-full no-scrollbar"
        >
          <table
            className="table-auto w-full border border-gray-300 m-auto"
            style={{
              position: "relative",
              minWidth: "700px",
              borderCollapse: "collapse",
              width: "100%",
            }}
          >
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2" style={{ fontSize: mobile ? "10px" : "16px" }}>#</th>
                <th className="border border-gray-300 px-4 py-2" style={{ fontSize: mobile ? "10px" : "16px" }}>
                  Size
                </th>
                <th className="border border-gray-300 px-4 py-2" style={{ fontSize: mobile ? "10px" : "16px" }}>
                  Name
                </th>
                <th className="border border-gray-300 px-4 py-2" style={{ fontSize: mobile ? "10px" : "16px" }}>
                  Number
                </th>
                <th className="border border-gray-300 px-4 py-2" style={{ fontSize: mobile ? "10px" : "16px" }}>
                  Category
                </th>
                <th className="border border-gray-300 px-4 py-2" style={{ fontSize: mobile ? "10px" : "16px" }}>
                  Quantity
                </th>
                <th className="border border-gray-300 px-4 py-2" style={{ fontSize: mobile ? "10px" : "16px" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {matchingGlbItem?.data
                ?.filter(Boolean)
                .map((row, rowIndex) => (
                  <tr key={`${item.cart_id}-${row.id}`} className="hover:bg-gray-50" style={{ fontSize: mobile ? "10px" : "16px" }}>
                    <td className="border border-gray-300 px-4 py-2">
                      {rowIndex + 1}
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <select
                        className="bg-transparent text-gray-700 border border-gray-300 rounded-md input-with-left-gap"
                        value={row.size_id || ""}
                        style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}
                        onChange={(e) =>
                          handleGlbSizeIdChange(
                            item.cart_id,
                            row.id,
                            Number(e.target.value)
                          )
                        }
                      >
                        <option value="" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Select</option>
                        {sizeAll?.map((sizeOption) => (
                          <option
                            key={sizeOption.id}
                            value={sizeOption.id}
                            style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}
                          >
                            {sizeOption.name}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td className="border border-gray-300" style={{ padding: mobile ? "3px" : "6px" }}>
                      <input
                        type="text"
                        style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "" }}
                        placeholder="Enter name"
                        value={row.name || ""}
                        onChange={(e) =>
                          handleGlbInputChange(
                            item.cart_id,
                            row.id,
                            "name",
                            e.target.value
                          )
                        }
                        className="w-full bg-white text-black border border-gray-300 rounded-md input-with-left-gap input-with-left-gap"
                      />
                    </td>
                    <td className="border border-gray-300" style={{ padding: mobile ? "3px" : "6px" }}>
                      <input
                        type="number"
                        style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "" }}
                        placeholder="Enter jersey number"
                        value={row.number || ""}
                        onChange={(e) =>
                          handleGlbInputChange(
                            item.cart_id,
                            row.id,
                            "number",
                            e.target.value
                          )
                        }
                        className="w-full bg-white text-black border border-gray-300 rounded-md input-with-left-gap input-with-left-gap"
                      />
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <select
                        className="w-full bg-transparent text-gray-700 border border-gray-300 rounded-md input-with-left-gap input-with-left-gap"
                        value={row.category || ""}
                        style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}
                        onChange={(e) =>
                          handleGlbInputChange(
                            item.cart_id,
                            row.id,
                            "category",
                            e.target.value
                          )
                        }
                      >
                        <option value="" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Select</option>
                        <option value="Men" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Men</option>
                        <option value="Women" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Women</option>
                        <option value="Kids" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Kids</option>
                      </select>
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <div
                        className="flex items-center gap-2 justify-center"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <button
                          onClick={() =>
                            handleGlbDecrement(
                              item.cart_id,
                              row.id,
                              row.qty
                            )
                          }
                          style={{
                            backgroundColor: "#003366",
                            borderRadius: "10px",
                          }}
                          className="px-3 py-1 text-white rounded-md input-with-left-gap"
                        >
                          -
                        </button>
                        <span className="text-gray-700">
                          {row.qty}
                        </span>
                        <button
                          onClick={() =>
                            handleGlbIncrement(
                              item.cart_id,
                              row.id,
                              row.qty
                            )
                          }
                          style={{
                            backgroundColor: "#003366",
                            borderRadius: "10px",
                          }}
                          className="px-3 py-1 text-white rounded-md input-with-left-gap"
                        >
                          +
                        </button>
                      </div>
                    </td>
                    <td className="border border-gray-300 px-4 py-2">
                      <div className="flex gap-2">
                        <button
                          onClick={() => {
                            if (rowIndex === 0) {
                              setDeleteTarget({
                                cart_id: item.cart_id,
                                data_id: row.id,
                                type: "glb",
                              });
                              setShowDeleteModal(true);
                            } else {
                              handleRemoveRow(
                                item.cart_id,
                                row.id
                              );
                            }
                          }}
                          className="px-3 py-1 text-white rounded-md input-with-left-gap"
                          style={{ backgroundColor: "transparent" }}
                        >
                          <RiDeleteBin5Line
                            style={{ color: "red" }}
                          />
                        </button>
                        <button
                          onClick={() =>
                            handleAddRow(item.cart_id)
                          }
                          className="px-3 py-1 text-white rounded-full"
                          title="Add Row Below"
                          style={{
                            backgroundColor: "transparent",
                          }}
                        >
                          <MdAdd
                            style={{ color: "rgb(0, 51, 102)" }}
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}

              {tempRows[item.cart_id]?.map((tempRow, index) => (
                <tr key={tempRow.id} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-4 py-2">
                    {matchingGlbItem?.data?.length + index + 1}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <select
                      className="bg-transparent text-gray-700 border border-gray-300 rounded-md input-with-left-gap input-with-left-gap"
                      value={tempRow.size_id}
                      style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}
                      onChange={(e) =>
                        handleGlbSizeIdChange(
                          item.cart_id,
                          tempRow.id,
                          Number(e.target.value)
                        )
                      }
                    >
                      <option value="" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Select</option>
                      {sizeAll?.map((sizeOption) => (
                        <option
                          key={sizeOption.id}
                          value={sizeOption.id}
                          style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}
                        >
                          {sizeOption.name}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="border border-gray-300" style={{ padding: mobile ? "3px" : "6px" }}>
                    <input
                      type="text"
                      style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "" }}
                      placeholder="Enter name"
                      value={tempRow.name}
                      onChange={(e) =>
                        handleGlbInputChange(
                          item.cart_id,
                          tempRow.id,
                          "name",
                          e.target.value
                        )
                      }
                      className="w-full bg-white text-black border border-gray-300 rounded-md input-with-left-gap"
                    />
                  </td>
                  <td className="border border-gray-300" style={{ padding: mobile ? "3px" : "6px" }}>
                    <input
                      type="number"
                      style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "" }}
                      placeholder="Enter jersey number"
                      value={tempRow.number}
                      onChange={(e) =>
                        handleGlbInputChange(
                          item.cart_id,
                          tempRow.id,
                          "number",
                          e.target.value
                        )
                      }
                      className="w-full bg-white text-black border border-gray-300 rounded-md input-with-left-gap"
                    />
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <select
                      className="w-full bg-transparent text-gray-700 border border-gray-300 rounded-md input-with-left-gap"
                      value={tempRow.category || ""}
                      style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}
                      onChange={(e) =>
                        handleGlbInputChange(
                          item.cart_id,
                          tempRow.id,
                          "category",
                          e.target.value
                        )
                      }
                    >
                      <option value="" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Select</option>
                      <option value="Men" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Men</option>
                      <option value="Women" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Women</option>
                      <option value="Kids" style={{ padding: mobile ? "1px" : "6px", fontSize: mobile ? "8px" : "16px", height: mobile ? "20px" : "", width: mobile ? "50px" : "" }}>Kids</option>
                    </select>
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <div
                      className="flex items-center gap-2 justify-center"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <button
                        onClick={() =>
                          handleGlbInputChange(
                            item.cart_id,
                            tempRow.id,
                            "qty",
                            tempRow.qty > 1 ? tempRow.qty - 1 : 1
                          )
                        }
                        style={{
                          backgroundColor: "#003366",
                          borderRadius: "10px",
                        }}
                        className="px-3 py-1 text-white rounded-md input-with-left-gap"
                      >
                        -
                      </button>
                      <span className="text-gray-700">
                        {tempRow.qty}
                      </span>
                      <button
                        onClick={() =>
                          handleGlbInputChange(
                            item.cart_id,
                            tempRow.id,
                            "qty",
                            tempRow.qty + 1
                          )
                        }
                        style={{
                          backgroundColor: "#003366",
                          borderRadius: "10px",
                        }}
                        className="px-3 py-1 text-white rounded-md input-with-left-gap"
                      >
                        +
                      </button>
                    </div>
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    <button
                      onClick={() =>
                        handleRemoveTempRow(
                          item.cart_id,
                          tempRow.id
                        )
                      }
                      className="px-3 py-1 text-white rounded-md input-with-left-gap"
                      style={{
                        backgroundColor: "transparent",
                      }}
                    >
                      <RiDeleteBin5Line
                        style={{ color: "red" }}
                      />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
})}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "16px",
                  marginBottom: "32px",
                }}
              >
                <button
                  className="add-product-button"
                  onClick={() => handleSportClick("cricket")}
                >
                  <MdAdd style={{ fontSize: "20px" }} />
                  Add More Product
                </button>
              </div>
            </div>

            {/* {product.length !== 0 || glb.length !== 0 ? (
              <div
                style={{
                  width: "100%",
                  margin: "20px auto",
                  padding: "20px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "10px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  // fontFamily: "Arial, sans-serif",
                }}
              >
                <form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "93%",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      marginBottom: "15px",
                      textAlign: "center",
                    }}
                  >
                    <p
                      className="middle1"
                      style={{ margin: "0", color: "#333", fontSize: "18px",fontFamily:"Poppins" ,fontWeight:'600'}}
                    >
                      Apply Coupon Code
                    </p>
                    <p
                      className="small1"
                      style={{
                        margin: "5px 0",
                        fontSize: "14px",
                        color: "#777",
                      }}
                    >
                      Enter your coupon code below to avail discounts.
                    </p>
                  </div>
                  <div
                    className="appplyCoupon"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Enter Coupon Code"
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                      style={{
                        flex: "1",
                        padding: "10px",
                        borderRadius: "5px",
                        border: "1px solid #ccc",
                        fontSize: "1.2rem",
                        color: "#555",
                        boxShadow: "inset 0 2px 4px rgba(0, 0, 0, 0.05)",
                      }}
                    />
                    <button
                      type="button"
                      onClick={applyCoupon}
                      disabled={isLoading}
                      style={{
                        padding: "10px 20px",
                        // backgroundColor: isLoading
                        //   ? "rgb(36, 111, 39)"
                        //   : "rgb(76, 175, 80)",
                        backgroundColor: "black",
                        // padding: "16px 0px",
                        borderRadius: "33px",
                        fontSize: "20px",
                        color: "white",
                        border: "none",
                        borderRadius: "5px",
                        // cursor: isLoading ? "not-allowed" : "pointer",
                        fontSize: "16px",
                        fontWeight: "bold",
                        transition: "background-color 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        minWidth: "150px",
                      }}
                      // onMouseEnter={(e) => {
                      //   if (!isLoading)
                      //      e.target.style.backgroundColor = "rgb(36, 111, 39)";
                      // }}
                      // onMouseLeave={(e) => {
                      //   if (!isLoading)
                      //     e.target.style.backgroundColor = "rgb(76, 175, 80)";
                      // }}
                    >
                      {isApplyingCoupon ? (
                        <div
                          style={{
                            width: "20px",
                            height: "20px",
                            border: "3px solid rgba(255, 255, 255, 0.3)",
                            borderTopColor: "#fff",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        ></div>
                      ) : (
                        "Apply Coupon"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            ) : (
              ""
            )} */}

            {/* {
              product.length !== 0 || glb.length !== 0 ?
              (
                <div style={{padding:"20px"}}>
                  <p style={{fontSize:"20px",fontWeight:"600"}}>
                    Applied Coupon Code:
                    {couponList[0].code}
                  </p>
                  </div>
              )
              :""
            } */}
            {product.length !== 0 || glb.length !== 0 ? (
              <div
                style={{
                  width: "100%",
                  padding: "20px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "10px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  // fontFamily: "Arial, sans-serif",
                }}
              >
                <p
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#333",
                  }}
                >
                  Total Price
                  <span style={{ color: "#007bff" }}>
                    ${totalPrice.toFixed(2)}
                  </span>
                </p>
                {/* <p
                  style={{
                    fontSize: "1.2rem",
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#555",
                  }}
                >
                  Coupon Discount
                  <span style={{ color: discountAmount ? "#ff4d4f" : "#aaa" }}>
                    ${
                      calculateCouponDiscount(couponList[0].quantity_discounts,product.length)
                    }
                  </span>
                </p> */}

                {/* <p
                  style={{
                    fontSize: "1.2rem",
                    marginBottom: "10px",
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#555",
                  }}
                >
                  Special Discount
                  <span style={{ color: discountAmount ? "#ff4d4f" : "#aaa" }}>
                    $
                    {quantityDiscountAmount
                      ? ` - ${quantityDiscountAmount}`
                      : 0}
                    
                  </span>
                </p> */}

               
                <p
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    color: "#333",
                    borderTop: "1px solid #ddd",
                    paddingTop: "10px",
                  }}
                >
                  Payable Amount {discountAmount ? "(5% discount)" : ""}
                  <span style={{ color: "#28a745" }}>
                    ${totalPrice.toFixed(2) }
                  </span>
                </p>
              </div>
            ) : (
              ""
            )}

            {product.length === 0 && glb.length === 0 ? (
              ""
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <button
                  style={{
                    marginTop: "20px",
                    padding: "14px",
                    width: "190px",
                    backgroundColor: "black",
                    // padding: "16px 0px",
                    borderRadius: "33px",
                    fontSize: "20px",
                    color: "#fff",
                    border: "none",
                    // borderRadius: "8px",
                    cursor: "pointer",
                    // fontSize: "1.2em",
                    fontWeight: "bold",
                    marginBottom: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  disabled={product.length === 0 && glb.length === 0}
                  onClick={() => handleProceedToCheckout(product, glb)}
                >
                  {isCheckingOut ? (
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "3px solid rgba(255, 255, 255, 0.3)",
                        borderTopColor: "#fff",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                      }}
                    ></div>
                  ) : (
                    "Checkout"
                  )}
                </button>
              </div>
            )}
            {/* <Discover /> */}
         
          </div>
          
        )}
           
      </>

      {showDeleteModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h2>Are you sure you want to delete this item?</h2>
            <p>This action will remove the entire cart entry for this item.</p>
            <div className="modal-actions">
              <button
                className="btn cancel"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="btn confirm"
                onClick={() => {
                  if (deleteTarget) {
                    console.log("deleteTarget : ", deleteTarget);
                    if (deleteTarget.type === "glb") {
                      console.log(
                        "eleteTarget.cart_id : ",
                        deleteTarget.cart_id
                      );
                      dispatch(
                        deleteEntireGlbCart({ cart_id: deleteTarget.cart_id })
                      );
                    } else if (deleteTarget.type === "product") {
                      console.log(
                        "deleteEntireProductCart : ",
                        deleteTarget.cart_id
                      );
                      dispatch(
                        deleteEntireProductCart({
                          cart_id: deleteTarget.cart_id,
                        })
                      );
                    }
                    console.log(
                      "deleteTarget.data_id : ",
                      deleteTarget.data_id
                    );
                    removeItem(deleteTarget.data_id);
                    setShowDeleteModal(false);
                  }
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default CartSec;
